import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollProgressBar = () => {
  const { pathname } = useLocation();
  const barRef = useRef(null);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return undefined;

    const update = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      if (barRef.current) {
        barRef.current.style.transform = `scaleX(${progress})`;
      }
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [pathname]);

  if (pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <div
      ref={barRef}
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] origin-left bg-gradient-to-r from-[#8bc934] via-[#b2f141] to-[#d4ff73]"
      style={{ transform: "scaleX(0)" }}
      aria-hidden="true"
    />
  );
};

export default ScrollProgressBar;
